import React from "react";
import CRUDAdmin from "../../components/admin/CRUDAdmin";

export default function FAQ() {
  return (
    <CRUDAdmin
      title="FAQs"
      subtitle="Common questions shown on the website."
      endpoint="/admin/faq"
      testIdPrefix="faq"
      defaults={{ active: true, order: 100 }}
      columns={[
        { title: "Question", render: r => <div className="serif text-lg">{r.q}</div> },
        { title: "Order", key: "order" },
      ]}
      fields={[
        { name: "q", label: "Question", full: true },
        { name: "a", label: "Answer", type: "textarea", full: true },
        { name: "order", label: "Order", type: "number" },
        { name: "active", label: "Active", type: "checkbox" },
      ]}
    />
  );
}
